import React from 'react';
import { Stack, Box, Typography } from '@mui/material';
import { AutocompleteMultiple } from 'components/AutocompleteMultiple';
import { ButtonGroupRadioSwitch } from 'components/ButtonGroupRadioSwitch';
import { useTargetingConfigContext } from './TargetingConfigContext';
import { industryOptions, companySizeOptions } from 'shared';

export const B2BConfig = () => {
  const { industry, setIndustry, companySize, setCompanySize } = useTargetingConfigContext();

  const industryAutocompleteValue = industry
    .map((ind) => industryOptions.find((indOpt) => indOpt.value === ind))
    .filter(Boolean);

  return (
    <Stack gap={5} alignItems="flex-start">
      <Box width={{ xs: '100%', sm: '55%' }}>
        <Typography fontWeight={700} mb={4}>
          Branche
        </Typography>
        <AutocompleteMultiple
          options={industryOptions}
          value={industryAutocompleteValue}
          onChange={(_, val) => setIndustry(val.map((v) => v.value))}
          label="Branche"
          placeholder="Branche wählen"
        />
      </Box>
      <Box>
        <Typography fontWeight={700} mb={4}>
          Unternehmensgrösse mit Anzahl Mitarbeiter
        </Typography>
        <ButtonGroupRadioSwitch
          multiple={true}
          value={companySize}
          onChange={setCompanySize}
          options={companySizeOptions}
          includeAllOption={true}
        />
      </Box>
    </Stack>
  );
};
